<template>
  <div class="tw-flex tw-items-center tw-justify-center tw-h-screen tw-bg-gray-50">
    <div class="tw-text-center">
      <!-- Error state -->
      <template v-if="callbackStatus === 'error'">
        <v-icon size="64" color="error" class="tw-mb-4">mdi-close-circle</v-icon>
        <p class="tw-text-lg tw-font-semibold tw-text-red-600 tw-mb-2">เชื่อมต่อไม่สำเร็จ</p>
        <p class="tw-text-sm tw-text-gray-500">กรุณาลองใหม่อีกครั้ง</p>
        <p v-if="!isPopup" class="tw-text-sm tw-text-gray-400 tw-mt-4">กำลังกลับไปหน้าตั้งค่า...</p>
      </template>

      <!-- Success state -->
      <template v-else>
        <v-icon size="64" color="success" class="tw-mb-4">mdi-check-circle</v-icon>
        <p class="tw-text-lg tw-font-semibold tw-text-green-700 tw-mb-2">เชื่อมต่อ Google Drive สำเร็จ</p>
        <p class="tw-text-sm tw-text-gray-500">
          {{ isPopup ? 'กำลังปิดหน้าต่างนี้...' : 'กำลังกลับไปหน้าตั้งค่า...' }}
        </p>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "OAuthCallback",
  data() {
    return {
      callbackStatus: "success",
      isPopup: false,
    };
  },
  mounted() {
    const status = this.$route.query.status;
    const companyId = this.$route.query.companyId;
    this.callbackStatus = status || "error";
    this.isPopup = !!window.opener;

    // Send result to parent window (the app) via postMessage
    if (window.opener) {
      window.opener.postMessage(
        {
          type: "GOOGLE_DRIVE_OAUTH_CALLBACK",
          status: status || "error",
          companyId: companyId || "",
        },
        window.location.origin
      );
      // Close popup after a short delay so user sees the result
      setTimeout(() => window.close(), 1500);
    } else {
      // Opened directly (not as popup) — redirect to settings page
      setTimeout(() => {
        if (companyId) {
          this.$router.replace(`/${companyId}/settings/ap-automation-prompt`);
        } else {
          this.$router.replace("/");
        }
      }, 2000);
    }
  },
};
</script>
